import React from "react";
import { ScrollView, ScrollViewProps } from "react-native";

type Props = ScrollViewProps & {
  children: React.ReactNode;
};

export const FormPageContainer: React.FC<Props> = ({
  children,
  className = "",
  ...rest
}) => {
  return (
    <ScrollView
      className={`flex-1 bg-white xs:bg-blue-900 ${className}`}
      contentContainerStyle={{
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
      contentContainerClassName="xs:px-3 xs:py-6"
      {...rest}
    >
      {children}
    </ScrollView>
  );
};

export default FormPageContainer;
